import close from '@assets/nuevos-iconos/x.png'
import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

export function IaGen() {
  const state = useLocation()
  const navigate = useNavigate()
  useEffect(() => {
    if (!document.body) {
      return
    }
    function handleKey(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        navigate('/ia')
      }
    }
    document.body.addEventListener('keydown', handleKey)
    return () => {
      document.body.removeEventListener('keydown', handleKey)
    }
  })
  return (
    <div>
      <Outlet />
      <div className=' white-background absolute right-24 top-5 z-10 mr-2 cursor-pointer'>
        <img
          onClick={() => {
            navigate('/ia')
          }}
          role='button'
          src={close}
          className='cursor-pointer'
        />
      </div>
      <img
        className=' white-background absolute left-1/2 top-1/2 z-50 flex h-fit w-fit -translate-x-1/2 -translate-y-1/2'
        src={state.state[0]}
      />
    </div>
  )
}
